<template>

  <div>
    <el-contianer>
      <el-table
        :data="tableData"
        border
        style="width: 98%;margin-top: 5%; margin-left: 1%;"
        >
        <el-table-column
          label="异常ID"
          prop="id">
        </el-table-column>
        <el-table-column
          label="资产固定编码"
          prop="propertyCode">
        </el-table-column>
        <el-table-column
          label="资产名称"
          prop="propertyName">
        </el-table-column>
        <el-table-column
          label="盘点状态"
          prop="exceptopnState"
          >
          <template slot-scope="scope">
            <el-tag
            :type="scope.row.exceptionState == 1?''
            :(scope.row.exceptionState==2?'success'
            :(scope.row.exceptionState==3?'info'
            :(scope.row.exceptionState==4?'danger'
            :(scope.row.exceptionState==5?'danger':'warning'))))"
            effect="dark">
              <div v-if="scope.row.exceptionState == 1">盘盈</div>
              <div v-if="scope.row.exceptionState == 2">盘亏</div>
              <div v-if="scope.row.exceptionState == 3">损毁待报废</div>
              <div v-if="scope.row.exceptionState == 4">闲置</div>
              <div v-if="scope.row.exceptionState == 5">信息不一致</div>


            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="审核人"
          prop="checker">
        </el-table-column>

        <el-table-column
          label="盘点任务名"
          prop="belongCheck">
        </el-table-column>
        <el-table-column
          label="盘点单名"
          prop="belongCheckTask">
        </el-table-column>


        <el-table-column label="操作">
            <template slot-scope="scope">
                  <el-button type="text" @click="table = true;GOTO(scope.row)">审核</el-button>


                  <el-drawer
                    title="审核界面!"
                    :visible.sync="table"
                    direction="rtl"
                    size="50%">



                    <el-form ref="form" :model="form" label-width="80px">

                      <el-form-item label="审核对象">
                          <el-input v-model.trim="form.name"></el-input>
                        </el-form-item>

                      <el-form-item label="审核状态">
                        <el-radio-group v-model="form.type">
                              <el-radio label="审核"></el-radio>
                              <!-- <el-radio label="已完成"></el-radio> -->
                              <el-radio label="驳回"></el-radio>
                            </el-radio-group>
                      </el-form-item>
                    </el-form>
                    <el-button @click="Up()" type="warning" round>审核上传</el-button>



                  </el-drawer>
              </template>
            </el-table-column>

      </el-table>

    </el-contianer>
    <div class="block">
             <el-pagination
               @size-change="showData"
               @current-change="showData"
               :current-page.sync="currentPage"
               :page-size="10"
               layout="prev, pager, next, jumper"
               :total="pageSize">
             </el-pagination>
           </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import Cookies from "js-cookie";
  export default {
     name: 'CheckWaitErrorData',
     data () {
       return {
         table:false,
         currentPage: 1,
         pageSize:1,
         form: {
                id:'',
                name: '',
                resource: '',
                 },
          tableData: [{
                  id:'',
                  placeId:'',
                  checkerId:'',
                  findId:'',
                  checkId:'',
                  taskId:'',
                  unitId:'',
                  state:'',
                  photo:'',
                  exceptionState:'',
                  propertyName:'',
                  propertySpecification:'',
                  propertyModel:'',
                  supplier:'',
                  del:'',
                  msg:'',
                  createDate:'',
                  holdPlace:'',
                  placeMgr:'',
                  checker:'',
                  finder:'',
                  belongCheck:'',
                       belongCheckTask:'',
                  unit:'',
                  propertyType:'',
                }],
        };
     },
     mounted:function() {
       this.showData();
     },
     methods: {
	   //上传异常审核数据，提交异常审核
       Up(){
         if(this.form.type=="审核"){
           var typeid = 2;
         }else{
           var typeid = 3;
         }

         var authorization = Cookies.get("Authorization");
         this.axios({
             method: 'POST',
             url: '/check/updateError',
             data:{
               errorId:this.form.id,
               state:typeid,
             },
             header:{
              'Authorization':authorization,
             	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
             	}
           }).then((resp)=>{
             if(resp.data.code == 200){
                this.open2()
             }else{
               this.open3(resp.data.message)
             }
           })
       },
       open2() {
               this.$message({
                 message: '恭喜你，审核通过了哦',
                 type: 'success'
               });
             },
       open3(val) {
              this.$message({
                message: val,
                type: 'warning'
              });
            },


		// 获取审核数据，得到待审核的资产名称以及Id
        GOTO(val){
          this.form.name = val.propertyName
          this.form.id = val.id
        },
		
		// 获取异常原始数据
        showData(val){
         var authorization = Cookies.get("Authorization");
         var params = {
           currentPage: val || 1,
           pageSize:10,
         }
          this.axios({
              method: 'GET',
              url: '/check/waitError',
              params:params,
              header:{
               'Authorization':authorization,
              	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
              	}
            }).then((resp)=>{
             this.tableData=resp.data.data;
             this.pageSize = resp.data.count;
            })
        },
     }
   }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Check/CheckWaitErrorData.vue